import React, { useEffect } from "react";
import { Form, Input, Switch, message } from "antd";
import { EditDivider, EditStageFormContainer } from "./styles";
import DefaultButton from "../../../../../../../shared/util/DefaultButton";
import { StageDto } from "../../../../../../../shared/dto/StageDto";
import StageProvider from "../../../../../../../shared/provider/StageProvider";

function EditStageForm({
  setOpen,
  isLoading = false,
  setLoading,
  setSuccessMesstage,
  requireStageList,
  stage,
  setEditMode,
}: {
  readonly setOpen: React.Dispatch<boolean>;
  readonly isLoading?: boolean;
  readonly setLoading: React.Dispatch<boolean>;
  readonly setSuccessMesstage: React.Dispatch<string>;
  readonly requireStageList: () => Promise<void>;
  readonly stage: StageDto;
  readonly setEditMode: React.Dispatch<boolean>;
}) {
  const [form] = Form.useForm();
  const stageProvider = new StageProvider();

  useEffect(() => {
    form.setFieldsValue({
      stageName: stage.title,
      stageDescription: stage.description,
      stageOrder: stage.order,
      isCompleted: stage.isCompleted,
    });
  }, [stage, form]);

  async function updateStage(values: any) {
    if (!values.stageName || !values.stageDescription || !values.stageOrder) {
      message.error("Preencha todos os campos");
      return;
    }

    setLoading(true);

    try {
      const orderValue = Math.min(Number(values.stageOrder), 50);

      const response = await stageProvider.createOrUpdate({
        stageId: stage.stageId,
        title: values.stageName,
        description: values.stageDescription,
        order: orderValue,
        isCompleted: values.isCompleted,
      });
      if (!response) throw new Error("Erro ao criar fase da idéia");
      setSuccessMesstage("Alterações salvas com sucesso!");
      setTimeout(() => requireStageList(), 550);
    } catch (error) {
      message.error("Erro ao alterar fase da idéia");
    } finally {
      setLoading(false);
    }
  }

  return (
    <EditStageFormContainer>
      <Form form={form} layout="vertical" onFinish={updateStage} requiredMark={false}>
        <Form.Item
          label="Nome da fase*"
          name="stageName"
          rules={[{ required: true, message: "Informe o nome da fase" }]}
        >
          <Input.TextArea
            showCount
            maxLength={100}
            autoSize={{ minRows: 1, maxRows: 3 }}
            disabled={isLoading}
          />
        </Form.Item>

        <EditDivider />

        <Form.Item
          label="Descrição"
          name="stageDescription"
          rules={[{ required: true, message: "Descreva a fase" }]}
        >
          <Input.TextArea
            showCount
            maxLength={400}
            autoSize={{ minRows: 3, maxRows: 6 }}
            disabled={isLoading}
          />
        </Form.Item>

        <Form.Item>
          <Form.Item
            label="Ordem"
            name="stageOrder"
            rules={[{ required: true, message: "Informe a ordem" }]}
            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
          >
            <Input
              type="number"
              min={0}
              max={50}
              disabled={isLoading}
            />
          </Form.Item>

          <Form.Item
            label="Fase final"
            name="isCompleted"
            valuePropName="checked"
            style={{ display: 'inline-block', width: 'calc(50% - 8px)', marginLeft: '16px' }}
          >
            <Switch checkedChildren="Ativo" unCheckedChildren="Inativo" disabled={isLoading} />
          </Form.Item>
        </Form.Item>

        <footer>
          <DefaultButton
            width="125px"
            height="36px"
            fontSize="1em"
            withOutBackground={true}
            params={{
              onClick: () => setOpen(false),
            }}
          >
            Fechar
          </DefaultButton>
          <DefaultButton
            width="125px"
            height="36px"
            fontSize="1em"
            params={{
              type: "button",
              onClick: () => form.submit(),
            }}
          >
            Salvar
          </DefaultButton>
        </footer>
      </Form>
    </EditStageFormContainer>
  );
}

export default EditStageForm;